import {useSelector} from "react-redux";
import {useEffect} from "react";
import config from "constants/config";
import useCookiesPolicy from "../../hooks/useCookiesPolicy";

import "./index.scss";


const Intercom = () => {

	const { isAuth, profile } = useSelector(({ auth }) => auth);
	const { allowIntercom } = useCookiesPolicy(false);

	useEffect(() => {
		if(isAuth) {
			if(profile && allowIntercom) {

				let ic = window.Intercom;

				if(typeof ic === "function") {
					ic('reattach_activator');
					ic('update', window.intercomSettings);
				} else {
					let intercom = function(){
						intercom.c(arguments);
					};
					intercom.q = [];
					intercom.c = function(args){
						intercom.q.push(args);
					};
					window.Intercom = intercom;

					let load = function() {
						let script = document.createElement('script');
						script.type='text/javascript';
						script.async=true;
						script.src='https://widget.intercom.io/widget/j3kaf0pd';
						let body = document.getElementsByTagName('script')[0];
						body.parentNode.insertBefore(script, body);
					};

					if(document.readyState === 'complete'){
						load();
					} else if(window.attachEvent){
						window.attachEvent('onload', load);
					} else {
						window.addEventListener('load', load,false);
					}

					console.log("Intercom Ready")
				}

				window.Intercom('boot', {
					app_id: config.INTERCOM_ID,
					name: profile.username,
					email: profile.email,
					subscription: profile.subscription ? profile.subscription.id === 2 ? "BUSINESS" : "PRO" : "FREE",
					user_id: profile.id,
					appsumo: profile.appsumo,
					user_hash: profile.intercom_hash,
					hide_default_launcher: false,
					custom_launcher_selector: '#intercom'
				});

			} else {

			}
		} else {
			window.Intercom && window.Intercom('update', {
				hide_default_launcher: true,
				custom_launcher_selector: '#intercom'
			});
		}

	}, [isAuth, profile, window && window.Intercom, allowIntercom, window && window.document && window.document.getElementById("intercom")])

	return null
}

export default Intercom